import { ApiResponseError } from '../../../types/errors';

export type TwoFactorErrorId = 'invalid_code';

export class TwoFactorError extends Error {
  public readonly id: TwoFactorErrorId;

  constructor(id: TwoFactorErrorId) {
    super(id);
    this.name = 'TwoFactorError';
    this.id = id;
    Object.setPrototypeOf(this, TwoFactorError.prototype);
  }
}

export type ConfirmPasswordErrorId = 'incorrect_password';

export class ConfirmPasswordError extends Error {
  public readonly id: ConfirmPasswordErrorId;

  constructor(id: ConfirmPasswordErrorId) {
    super(id);
    this.name = 'ConfirmPasswordError';
    this.id = id;
    Object.setPrototypeOf(this, ConfirmPasswordError.prototype);
  }
}

/** Every 2FA management route carries Fortify's `password.confirm` middleware, which responds
 * 423 for a session whose password confirmation has expired or never happened. */
export function isPasswordConfirmationRequiredError(err: unknown): boolean {
  return err instanceof ApiResponseError && err.status === 423;
}
